module.exports = __webpack_public_path__ + "img/SOUTHASIA_FERMENTED_MILK.c5f67be7.png";